import { useTriviaContext } from "../context-trivia";
import { TriviaButtonHelp } from "../TriviaButtonHelp/TriviaButtonHelp";

export function TriviaQuestionHelp() {
  const { config, machine, activateHelp } = useTriviaContext();

  return (
    <div
      className="flex flex-row items-center justify-center py-[var(--trivia-space)]"
      style={{
        backgroundColor: config.theme.panelColor,
        borderRadius: "var(--trivia-radius)",
      }}
    >
      <TriviaButtonHelp
        help="fiftyFifty"
        icon="filter"
        text="50/50"
        disabled={machine.usedHelp.includes("fiftyFifty")}
        onHandleMouse={activateHelp}
      />
    </div>
  );
}
